import { useNavigate } from "react-router-dom";

const MINI_DOC_VIDEO_URL = "https://kennedyryon.com/files/69f9f0d2953774019530485d";
const MINI_DOC_POSTER_URL = "https://kennedyryon.com/files/69fa5deb9537740195305000";

export function MiniDocPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white px-8 pt-[max(2rem,calc(2rem+env(safe-area-inset-top)))] pb-[max(2rem,calc(2rem+env(safe-area-inset-bottom)))]">
      <div className="max-w-4xl mx-auto space-y-6">
        <button
          type="button"
          onClick={() => navigate("/")}
          className={
            "inline-flex items-center justify-center min-h-11 px-6 rounded-full " +
            "text-sm font-semibold bg-primary text-primary-foreground whitespace-nowrap " +
            "shadow-md hover:shadow-lg hover:-translate-y-0.5 hover:brightness-110 active:translate-y-0 active:brightness-95 " +
            "transition-[transform,box-shadow,filter] duration-200 cursor-pointer " +
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-black"
          }
        >
          Back to player
        </button>

        <div>
          <h1 className="mb-4">
            <span className="block text-sm font-medium text-primary/90">Mini-Doc:</span>
            <span className="block text-xl font-bold text-white mt-1">10 Days of Evolution</span>
          </h1>
          <video
            controls
            playsInline
            poster={MINI_DOC_POSTER_URL}
            src={MINI_DOC_VIDEO_URL}
            className="w-full rounded-lg shadow-xl bg-black"
          >
            Your browser does not support embedded video.
          </video>
        </div>
      </div>
    </div>
  );
}
